enum BillingPlanIdEnum {
  BrokerProMonthly = 'Broker-Pro-USD-Monthly',
  BrokerProYearly = 'Broker-Pro-USD-Yearly',
  FreemiumMonthly = 'Freemium-USD-Monthly'
}

export default BillingPlanIdEnum;
